var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAddLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 10.6668,
    rx: 5.33333,
    ry: 5.33333,
    fill: "#0E1596",
    stroke: "#0E1596",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6542 22.0002C21.4056 21.8893 21.1511 21.7857 20.8912 21.6896C18.925 20.9624 16.7224 20.6907 14.5586 20.9044C12.3952 21.118 10.353 21.8087 8.69222 22.901C7.03133 23.9935 5.81444 25.4475 5.22594 27.0947C5.13303 27.3548 5.26853 27.6409 5.52857 27.7338C5.78862 27.8267 6.07474 27.6912 6.16764 27.4312C6.67118 26.0217 7.73036 24.7306 9.24174 23.7365C10.7532 22.7424 12.637 22.099 14.6568 21.8995C15.8843 21.7783 17.1229 21.825 18.3139 22.0312C18.4284 22.0108 18.5463 22.0002 18.6667 22.0002L21.6542 22.0002Z",
    fill: "#0E1596"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18.6665L24 29.3332",
    stroke: "#0E1596",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3334 24L18.6667 24",
    stroke: "#0E1596",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAddLight);
export default __webpack_public_path__ + "static/media/User_add_light.32e9c001d8feb8120c8c7248aca16efd.svg";
export { ForwardRef as ReactComponent };